import React, { useEffect, useState } from "react";
import MaterialTable from "@material-table/core";
import { ExportCsv } from "@material-table/exporters";
import { deleteOneIn, getAllIn } from "../../../../services/crudCustom";
import moment from 'moment';
import DetailIcon from '@mui/icons-material/ArticleOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';

import { AppBar, Box, Button, Dialog, Grid, IconButton, Toolbar, Typography } from "@mui/material";
import Swal from "sweetalert2";
import { ArticleOutlined, ViewListOutlined } from "@mui/icons-material";
import { CloseOutlined } from "@material-ui/icons";
import { VisualizarResumenes } from "../../VisualizarResumenes";
import { ReporteDeTrabajos } from "../../ReporteDeTrabajos";
import { CustomDialog } from "../../../modules/dialogs/CustomDialog";


export const CustomTable = ({ event }) => {
    //* Desestructurar aqui, utilizar en useEffect
    const { tabla, claveProyecto, solicitudFolio } = event;

    // state para visualizarResumenes
    const [visualizarResumenes, setVisualizarResumenes] = useState(false);
    
    // state para visualizarReporteDeTrabajos
    const [visualizarReporteDeTrabajos, setVisualizarReporteDeTrabajos] = useState(false);

    // state para almacenar la data 
    const [records, setRecords] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    
    // Columnas para presentar en la tabla
    const columns = [
        { title: 'Referencia', field: 'registroReferencia' },
        { title: 'Nombre completo', field: 'partNombreCompleto', },
        { title: 'Requiere factura', field: 'hasPaid', },
    ];


    // Se ejecuta en la 'action'
    const exportData = () => {

        const item = records[0];

        // Convertir a array las 'keys' de cada par key-value del objeto
        const keys = Object.keys(item);
 
        const columnsToExport = [];

        keys.forEach( e => (
            // Regex para separar en palabras una cadena que viene en camelcase
            columnsToExport.push( {title: e.replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase(), field: e })
        ));

        const timeNow = moment().format('YYYYMMDDTHHmmss').toString();

        ExportCsv(columnsToExport, records, `${event.tabla}_${timeNow}`)
    }


    const showDetails = (data) => {
        // Se abre otra ventana con el detalle
        const numReferencia = data.registroReferencia || data.refBancaria;
        const urlToGo = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${numReferencia}`
        window.open(urlToGo);
    }

    const deleteItem = async(item) => {

        Swal.fire({
            title: `¿Eliminar el registro ref. ${ item.registroReferencia }?`,
            text: "Esta acción no se puede deshacer.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
        }).then(async(result) => {
            if (result.isConfirmed) {

                await deleteOneIn({ table:'RegistroGeneral', id:item.id });
                // if (claveProyecto.startsWith("0")) {
                //     await deleteOneIn({ table:'RegistroGeneral', id:item.id });
                // } else {
                //     await deleteOneIn({ table:event.tabla, id:item.id });
                // }
                
                // Aqui se debe actualizar el listado
                loadRecords();
            }
        })
    }


    const loadRecords = async() => {
        setIsLoading(true);

        const { exito, mensaje, data: records } = await getAllIn({ table:'RegistroGeneral' });

        // Hubo un error, muestralo en consola y regresa null
        if (exito === 0) { console.log(mensaje); return; }
        console.log({solicitudFolio});

        records.forEach( record => {
            record.infoAdicional = JSON.parse(record.infoAdicional);
        });
        console.log({records});

        const recordsFiltered = records.filter(r => r.infoAdicional.educonSolicitudId == solicitudFolio);

        recordsFiltered.forEach(rf => {
            const registroConfirma = rf.infoAdicional.registroConfirma ? rf.infoAdicional.registroConfirma : 'No aplica';
            const registroConfirmaFecha = registroConfirma && rf.infoAdicional.registroConfirmaFecha;
            // console.log({registroConfirma});
            rf.partNombreCompleto = `${ rf.partNombres } ${ rf.partApellidoPaterno } ${ rf.partApellidoMaterno }`;
            rf.hasPaid = registroConfirmaFecha === "" ? 'Pendiente' : rf.infoAdicional.registroConfirmaFecha.slice(0, 10);
            // rf.hasPaid = (rf.infoAdicional.registroConfirma !== 0) 
            // ? rf.infoAdicional.registroConfirma ? rf.infoAdicional.registroConfirmaFecha : 'No aplica'
            // : 'Pendiente';
        })
        // const recordsFiltered = [];
        // records.forEach( record => {
        //     // record.infoAdicional = JSON.parse(record.infoAdicional);
            
        //     const infoAdicional = JSON.parse(record.infoAdicional);
        //     const { educonSolicitudId } = infoAdicional;
        //     // console.log({educonId});
        //     if (educonSolicitudId == solicitudFolio) {
        //         recordsFiltered.push({
        //             ...record,
        //             infoAdicional: infoAdicional,
        //             partNombreCompleto: `${ record.partNombres } ${ record.partApellidoPaterno } ${ record.partApellidoMaterno }`,
        //             hasPaid: (infoAdicional.registroConfirma !== 0) 
        //             ? (infoAdicional.registroConfirma === 1) 
        //                 ? infoAdicional.registroConfirmaFecha 
        //                 : 'No aplica'
        //             : 'Pendiente'
        //         });
        //     }

            //!

            // const cProyecto = record.registroClaveProyecto || record.claveProyecto;
            // if (cProyecto === claveProyecto) {
            //     // console.log({infoAdicional});
            //     recordsFiltered.push({
            //         ...record,
            //         infoAdicional: infoAdicional,
            //         partNombreCompleto: `${ record.partNombres } ${ record.partApellidoPaterno } ${ record.partApellidoMaterno }`,
            //         hasPaid: (infoAdicional.registroConfirma !== 0) 
            //         ? (infoAdicional.registroConfirma === 1) 
            //             ? infoAdicional.registroConfirmaFecha 
            //             : 'No aplica'
            //         : 'Pendiente'
            //     });
            // }
        // });
        // console.log({ records });
        console.log({ recordsFiltered });
        setRecords(recordsFiltered);
        setIsLoading(false);
    }


    useEffect(() => {
        
        const getData = async() => {
            
            if ( tabla !== '' ) {
                loadRecords();
            }
        }
        getData();

    }, [ event, tabla, claveProyecto ])
    

    const visualizarResumenesPressed = () => {
        setVisualizarResumenes(true);
    }

    const toogleVisualizarResumenes = () => {
        setVisualizarResumenes(!visualizarResumenes);
    }

    const toogleVisualizarReporteDeTrabajos = () => {
        setVisualizarReporteDeTrabajos(!visualizarReporteDeTrabajos);
    }

    const listaAsistenciaPressed = () => {
        console.log(event);
        const urlToGo = `${ process.env.REACT_APP_HOMEPAGE }/admin/reporte-de-asistencia/${ event.claveProyecto }`
        console.log(urlToGo);
        window.open(urlToGo);
    }

    return (
        <>
            <CustomDialog show={ isLoading } title='Cargando información...' />

            <Grid container >
                {/* Acceso a todos los resumenes */}
                {
                    (tabla !== '') &&
                    <Box 
                        xs={12} 
                        display='flex' 
                        flexDirection='row' 
                        spacing={ 2 } 
                        sx={{ my: 1 }}
                    >
                        <Button 
                            variant="outlined" 
                            onClick={ () => listaAsistenciaPressed() }
                            sx={{ mx: 1 }}
                        >
                            <ViewListOutlined /> Lista de asistencia
                        </Button>
                        {
                            // Aqui se agregan los valores de la tabla para los eventos que requieran del modulo 'VisualizarResumenes.jsx'
                            (tabla === 'Simac2023') &&
                                <Button 
                                    variant="outlined" 
                                    onClick={ () => visualizarResumenesPressed() }
                                    sx={{ mx: 1 }}
                                >
                                    <ViewListOutlined /> Visualizar resumenes
                                </Button>
                        }
                        {
                            // Aqui se agregan los valores de la tabla para los eventos que requieran del modulo 'ListaDeResumenes.jsx'
                            (tabla === 'Rnav23') &&
                                <Button 
                                    variant="outlined" 
                                    onClick={ toogleVisualizarReporteDeTrabajos }
                                    sx={{ mx: 1 }}
                                >
                                    <ArticleOutlined sx={{ mr: 1 }}/> Reporte de trabajos
                                </Button>
                        }
                    </Box>
                }
                {/* { (tabla === 'Simac2023') &&
                    <Grid item xs={12}>
                        <Button variant="outlined" onClick={ () => visualizarResumenesPressed() }  sx={{ mb: 2 }}>
                            <ViewListOutlined /> Visualizar resumenes
                        </Button>
                    </Grid>
                } */}

                {/* Tabla con los registros */}
                <Grid item xs={12}>
                    <MaterialTable
                        title={ event.tituloEvento }
                        columns={ columns }
                        data={ records }
                        actions={[
                            {
                                icon: DetailIcon,
                                tooltip: 'Detalles',
                                onClick: (_, rowData) => showDetails( rowData )
                            },
                            // {
                            //     icon: EditIcon,
                            //     tooltip: 'Editar',
                            //     onClick: (_, rowData) => { editElement( rowData ); }
                            // },
                            {
                                icon: DeleteIcon,
                                tooltip: 'Eliminar',
                                onClick: (_, rowData) => deleteItem(rowData)
                            },
                        ]}
                        options={{ 
                            actionsColumnIndex: -1, 
                            exportMenu: [{
                                label: 'Exportar CSV', exportFunc: () => exportData()
                            }]
                        }}
                        localization= {{ 
                            header: { actions: '' },
                            toolbar: { 
                                searchPlaceholder: 'Buscar', 
                                exportTitle: 'Exportar' 
                            },                    
                            pagination: { 
                                labelRowsPerPage: '', 
                                labelRowsSelect: 'registros' 
                            },                    
                        }}
                    />
                </Grid>

                {/* Visualizar resumenes dialog */}
                <Dialog
                    fullScreen
                    open={visualizarResumenes}
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButton
                            edge="start"
                            color="inherit"
                            onClick={ toogleVisualizarResumenes }
                            aria-label="close"
                            >
                                <CloseOutlined />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                Visualizar resumenes
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <VisualizarResumenes event={ event } />

                </Dialog>

                {/* Visualizar reporte de trabajos dialog */}
                <Dialog
                    fullScreen
                    open={ visualizarReporteDeTrabajos }
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButton
                            edge="start"
                            color="inherit"
                            onClick={ toogleVisualizarReporteDeTrabajos }
                            aria-label="close"
                            >
                                <CloseOutlined />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                Reporte de trabajos
                            </Typography>
                        </Toolbar> 
                    </AppBar>

                    <ReporteDeTrabajos records={ records } />
                </Dialog>
            </Grid>
        </>
    );
};
